/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGlobalSearch, useProcess } from "@/global-data";
import { useDeletePopup } from "@/global-data/use-delete-popup";
import { useDebouncedValue } from "@/hooks/use-debounced-value";
import { useToast } from "@/hooks/use-toast";
import { getUserInfo } from "@/lib/token";
import { wait } from "@/lib/wait";
import { apiServices } from "@/services/api.services";
import { validation, synonym } from "@/services/global.services";
import { GenericType } from "@/types";
import { useEffect, useMemo, useState } from "react";

export const useMutations = () => {
  const { toast } = useToast();

  const API_SERVICE = validation;
  const { company_id, user_id } = useMemo(() => {
    const tempUserData = getUserInfo();
    return {
      company_id: tempUserData?.company_id,
      user_id: tempUserData?.user_id || "",
    };
  }, []);
  const { setProcess } = useProcess();
  const [skeltonLoading, setSkeltonLoading] = useState(true);
  const [listData, setListData] = useState([]);
  const [companyData, _setCompanyData] = useState([]);
  const [filter, setFilter] = useState({});
  const [formPopupOpen, setFormPopupOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(undefined);
  const [activeRecordData, setActiveRecordData] = useState<any>(undefined);
  const [tableColumn, setTableColumn] = useState([]);

  const [synonymList, setSynonymList] = useState<any>([]);
  const [domainList, setDomainList] = useState<any>([]);

  const { setSearchProgress, search } = useGlobalSearch();
  const [searchDebounced] = useDebouncedValue(search, 200);

  const { onDelete, status, identity, clearDelete } = useDeletePopup();

  const [paginationData, setPaginationData] = useState({
    page: 1,
    perPage: 10,
    totalItem: 1,
  });

  const [errorMessage, setErrorMessage] = useState<any>({
    title: "",
    message: "",
    open: false,
  });

  const closeErrorMessage = () => {
    setErrorMessage({
      title: "Error",
      message: "",
      open: false,
    });
  };

  //On Load Component
  useEffect(() => {
    (async () => {
      await loadingList({ searchText: "" });
      await loadingDomain();
      // await loadingSynonym();
      await wait(1000);
      setSkeltonLoading(false);
      setProcess(false);
    })();
    return () => {
      closeErrorMessage();
    };
  }, []);

  //handle delete
  useEffect(() => {
    if (status === "cancel") {
      setDeleteId(undefined);
      clearDelete();
    }
    if (status === "delete" && identity === "user") {
      (async () => {
        setProcess(true);
        const deleteResponse = await deleteRecord();
        if (deleteResponse.data) {
          await loadingList({});
          toast({
            title: "Success",
            variant: "success",
            description:
              deleteResponse?.data.result.metadata.message ??
              deleteResponse?.data?.status?.msg ??
              deleteResponse?.data?.status?.message,
          });
        }
        clearDelete();
        setDeleteId(undefined);
        setProcess(false);
      })();
    }
  }, [status]);

  const deleteRecord = async () => {
    const payload = {
      data: {
        validation_id: deleteId,
        // company_id: company_id,
      },
      company_id: company_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.delete,
      "post",
      payload
    );

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  function getErpKeys(obj: GenericType, prefix: string = "") {
    let result: Array<Record<string, string>> = [];
    for (const key in obj) {
      const fullKey = prefix ? `${prefix}.${key}` : key;

      // Remove the first parent key from both label and value
      const trimmedKey = fullKey.includes(".")
        ? fullKey.substring(fullKey.indexOf(".") + 1)
        : "";

      if (trimmedKey) {
        result.push({ label: trimmedKey, value: trimmedKey });
      }

      if (
        typeof obj[key] === "object" &&
        obj[key] !== null &&
        !Array.isArray(obj[key])
      ) {
        result = result.concat(getErpKeys(obj[key], fullKey));
      }
    }
    return result;
  }

  const loadingSynonym = async (prop: string) => {
    const payload = {
      data: {
        domain_name: prop,
      },
      company_id: company_id,
      user_id: user_id,
    };
    setProcess(true);
    const { data, error, message } = await apiServices<GenericType>(
      "/synonym_schema/get",
      "post",
      payload
    );

    if (data) {
      const synonymListData = getErpKeys(
        data.result.metadata["synonym_schema"]
      );
      setSynonymList(synonymListData);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    setProcess(false);
    return { data, error };
  };

  const loadingDomain = async () => {
    const payload = {
      data: {
        // username: userData?.username,
        filter_by: {
          search_text: "",
          exact_match: false,
          //"delivery_type": this.delivery_type,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      synonym.get,
      "post",
      payload
    );

    if (data) {
      const localList: any = [];
      const listData = data.result.metadata[synonym.key];
      for (const item of listData) {
        localList.push({ label: item.domain_name, value: item.domain_name });
      }
      setDomainList(localList);
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  //Handle Search
  useEffect(() => {
    if (skeltonLoading === false) {
      (async () => {
        setSearchProgress(true);
        /* const response =  */ await loadingList({});
        setSearchProgress(false);
      })();
    }
  }, [searchDebounced]);

  const onFormOpenChange = (prop: boolean) => {
    setFormPopupOpen(prop);
  };

  const onPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, page: prop }));
    setProcess(true);
    await loadingList({ page: prop });
    setProcess(false);
  };
  const onPerPageChange = async (prop: number) => {
    setPaginationData((prev) => ({ ...prev, perPage: prop, page: 1 }));
    setProcess(true);
    await loadingList({ perPage: prop, page: 1 });
    setProcess(false);
  };

  const permission: any = [];
  const onAction = async ({ action, data }: any) => {
    if (action === "edit") {
      setActiveRecordData(data);
      onFormOpenChange(true);
    }
    if (action === "delete") {
      setActiveRecordData(data);
      setDeleteId(data.validation_id);
      onDelete({
        description:
          "This action cannot be undone. This will permanently delete the record and remove its data from our system.",
        id: data.user_id,
        identity: "user",
        popupStatus: true,
        title: "Are you sure you want to delete this validation?",
      });
      await loadingList({});
    }
  };

  useEffect(() => {
    if (formPopupOpen === false) {
      setActiveRecordData(undefined);
      closeErrorMessage();
    }
  }, [formPopupOpen]);

  const loadingList = async ({
    perPage,
    page,
    filterReset,
    makeFilter,
    searchText,
  }: {
    perPage?: number;
    page?: number;
    filterReset?: boolean;
    makeFilter?: boolean;
    searchText?: string;
  }) => {
    let apiFilter = {};

    if (!filterReset) {
      apiFilter = filter;
    }
    let page_no = page || paginationData.page;

    if (makeFilter) {
      page_no = 1;
    }

    const payload = {
      data: {
        filter_by: {
          ...apiFilter,
          search_text: searchText ?? searchDebounced,
          exact_match: false,
          pagination: {
            page_no: page_no,
            no_of_recs: perPage || paginationData.perPage,
            sort_by: "cts",
            order_by: false,
          },
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      API_SERVICE.get,
      "post",
      payload
    );

    if (data) {
      setListData(data.result.metadata[API_SERVICE.key]);
      setPaginationData((prev) => ({
        ...prev,
        totalItem: data?.result?.metadata?.total_records || 1,
      }));
    }
    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  function buildExpressionFromArray(arr: any[]) {
    const filtered = arr.filter((item) => item.label?.trim() !== "");

    return filtered
      .map((item, index) => {
        const isLast = index === filtered.length - 1;
        const hasOperator = item.operator && item.operator.trim() !== "";
        return (
          item.label + (!isLast && hasOperator ? ` ${item.operator} ` : "")
        );
      })
      .join("")
      .trim();
  }

  const onFormSubmit = async (prop: any): Promise<any> => {
    let formData = {};
    // const method = activeRecordData ? "patch" : "post";
    // const url = activeRecordData ? API_SERVICE.update : API_SERVICE.post;
    // const expression_list = prop.expression.filter(
    //   (item: string) => item !== ""
    // );
    // const expression_list = [
    //   ...new Set(prop.expression.filter((item: string) => item !== "")),
    // ];

    const expression_list = buildExpressionFromArray(prop.expression);

    if (expression_list === "") {
      setErrorMessage({
        title: "Error",
        message: "expression should not be empty",
        open: true,
      });
      return {
        error: {
          expression: "expression should not be empty",
        },
      };
    }
    if (activeRecordData) {
      formData = {
        validation_id: activeRecordData?.validation_id,
        expression: expression_list,
        result: prop.result,
        domain_name: prop.domain_name,
      };
    } else {
      formData = {
        is_new: true,
        expression: expression_list,
        result: prop.result,
        domain_name: prop.domain_name,
      };
    }

    const payload = {
      data: formData,
      company_id: company_id,
      user_id: user_id,
    };

    console.log({ payload });

    const { data, error, message } = await apiServices<any>(
      API_SERVICE.post,
      "post",
      payload
    );

    if (data) {
      const response = await loadingList({});
      if (response.data) {
        // toast({
        //   title: "Success",
        //   variant: "success",
        //   description: data.status.msg,
        // });
        toast({
          title: "Success",
          variant: "success",
          description:
            data.result.metadata.message ??
            data?.status?.msg ??
            data?.status?.message,
        });
      }
    }

    if (error) {
      setProcess(false);
    }

    if (error) {
      setErrorMessage({
        title: "Error",
        message: error.status?.message || message,
        open: true,
      });
      // toast({
      //   title: "Error",
      //   variant: "destructive",
      //   description: error.status?.message || message,
      // });
    }
    return { data, error };
  };

  const filterRequest = async () => {
    setProcess(true);
    await loadingList({ makeFilter: true });
    setProcess(false);
  };
  const clearFilter = async () => {
    setFilter({});
    setProcess(true);
    await loadingList({ filterReset: true });
    setProcess(false);
  };

  return {
    skeltonLoading,
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    tableColumn,
    setTableColumn,
    companyData,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    synonymList,
    domainList,
    loadingSynonym,
    errorMessage,
    closeErrorMessage,
  };
};
